module.exports = __webpack_public_path__ + "static/media/approval-manager.766ad645.svg";